import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.Header = React.createClass({
  componentDidMount: function() {

    let $jobModal = $('#job-modal')

    $jobModal.find('.modal-header .close').on('click', () => {
      if(Job.Data.lastSlide) {
        redirectPage()
        return;
      }

      if (this.props.hideCloseModalWarning) {
        $jobModal.modal('hide')
      } else {
        let $warning = $jobModal.find('.close-modal-warning')
        if ($warning.is(':hidden')) {
          $warning.velocity('slideDown')
          $(this).addHidden()
        }
      }
    })

    function redirectPage() {
      let jobID = Job.Data.id
      let url = ''
      switch (Job.Data.referrer.cta) {
        case 'profile': {
          url = `/jobs/${jobID}/profilejob?successful_job=true`
        }
        case 'business_directory_card': {
          url = `/jobs/${jobID}/bcardjob?successful_job=true`
        }
        default: {
          url = `/jobs/${jobID}/posted?successful_job=true`
        }
      }
      document.location.href = url 
    }
  },

  render: function() {
    return (
      <div className="modal-header question-header no-border-bottom mr32 ml32 p0 pb16">
        <button type="button" className="close" aria-label="Close"><span aria-hidden="true" className="ficon-delete font-14" style={{top: '-11px', right:'0px', position:'absolute'}}></span></button>
      </div>
    )
  }
})
